import React, { useEffect, useState } from "react";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import Footer from "../components/Footer/Footer";
import PayPal from "../components/Paypal";
import TopBar from "../components/TopBar";
import { useLocation } from "react-router-dom";
import PageLoader from "../components/PageLoader";

const Checkout = () => {

  const [interview, setInterview] = useState([]);
  const [pkg, setPackage] = useState([]);
  const [pageLoader, setLoading] = useState(false);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const interview_id = urlParams.get("interview_id") ?? "";
  const package_id = urlParams.get("package_id") ?? "";

  const currency = process.env.REACT_APP_CURRENCY;

  const getInterviewDetails = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get(
        "/getInterviewDetails?interview_id="+interview_id
      );
      setInterview(response.data.data);
    } catch (error) {
      toast.error("Failed to load interview details.");
    } finally {
      setLoading(false);
    }
  };
  const getPackageDetails = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get(
        "/getPackageDetails/"+package_id
      );
      setPackage(response.data.data);
    } catch (error) {
      toast.error("Failed to load interview details.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (interview_id > 0) {
      getInterviewDetails();
    }
    else if(package_id > 0){
      getPackageDetails();
    }
  }, []);

if (pageLoader) {
  return (
    <PageLoader />
  );
}else{

  return (
    <div>
     
     <TopBar />

      <div className="container my-5 main-sec">
          <h3>Checkout</h3>
          <div className="row">
            <div className="col-md-4">
              <div className="card border p-3">
                { interview_id > 0 ?( 
                  <div className="details">
                    <img src={interview.thumbnail} alt="thumbnail" width={'100px'} />
                    <h5>  {interview.title} </h5> <br />
                    <h4>Price: {currency} {interview.price} </h4>
                    <h6>Expiry: {interview.duration} {interview.duration_type}</h6>
                    <p>Description goes here</p>
                  </div>
                ) :(
                  <div className="details">
                    <h4>  {pkg.name} </h4> <br />
                    <h4>Price:  {currency} {pkg.price} </h4>
                    <h6>Expiry: {pkg.duration} {pkg.duration_type}</h6>
                    <p>{pkg.description}</p>
                  </div>
                )}

              </div>
            </div>
            <div className="col-md-8">
              <div className="card border p-3">
                  <h5 className="mb-5">Payment Methods:</h5>
                  <div className="w-75 mx-auto">
                      <PayPal package_id={package_id} interview_id={interview_id} amount={interview_id > 0 ? interview.price: pkg.price} />
                  </div>

              </div>
            </div>
          </div>
     
      </div>

      <div className="pos-stick">
        <Footer />
      </div>
    </div>
  );
  
}


};

export default Checkout;
